const Reflux = require('reflux');
const superagent = require('superagent');

const SearchActions = Reflux.createActions({
  getSuggestions: {asyncResult: true}
});


SearchActions.getSuggestions.listen(function(input, config) {
  superagent.
    get(`${config.projects.url}/api/search/suggest`).
    query({input: input}).
    withCredentials().
    end((error, response) => {
      !error && response.ok ?
        this.completed(response.body)
      : this.failed(error || response);
    });
});


module.exports = {SearchActions}



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/SearchBar/SearchActions.es6
 **/